import { Component } from 'react';

import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { UploadInProgressFile } from '../../models/upload-in-progress-file';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { ConvertOption, ConvertOptionCategories, ConvertOptionCategoy } from '../../types/dropdown.type';
import { RouteProps } from '../../types/route-types';
import { RouteUtils } from '../../utils/route.utils';
import ConvertOptionComponent from './convert-option.component';
import { ConvertOptionsContext, HTMLWidgetChangeEvent } from './convert-options-context';
import styles from './convert-options.component.module.scss';

export interface ConvertOptionsComponentProps extends RouteProps {
    convertOptionCategories: ConvertOptionCategories;
    convertOptionsContext: ConvertOptionsContext;
    uploadInProgressFiles?: UploadInProgressFile<any>[];
    onOptionChange: (data) => void;
}

export default class ConvertOptionsComponent extends Component<ConvertOptionsComponentProps> {
    // @ViewChildren('convertOption') convertOption s: ConvertOptionComponent[]; // TODO Preact need ref array

    private url: string;
    @lazyInject(IOC_TYPES.PageDataProviderService) private optionsService: PageDataProviderService;

    constructor(props: ConvertOptionsComponentProps) {
        super(props);
    }

    componentDidMount() {

        this.url = RouteUtils.getPathFromProps(this.props);
        this.props.convertOptionsContext.onSelectedOptionsChanged.subscribe({
            next: (change: HTMLWidgetChangeEvent) => {
                // if (change.formChild && change.formChild && 
                //     change.formChild.formGroupName === 'outputExtension') {
                //     this.forceUpdate();
                // }
                this.forceUpdate();
            }
        });
    }


    public shouldDisplay(convertOption: ConvertOption) {
        // return true;
        // TODO Preact fix
        return !(convertOption.hiddenFn && convertOption.hiddenFn(this.props.convertOptionsContext.getConvertOptionCategories() as any));
    }

    public shouldDisplayCategory(convertOption: ConvertOptionCategoy) {
        return !(convertOption.hiddenFn && 
            convertOption.hiddenFn(this.props.convertOptionsContext));
    }

    onOutputExtensionSelect() {
    }

    hasSelectableOptions() {
        if (this.props.convertOptionCategories.formCategories.length === 1) {
            return this.props.convertOptionCategories.formCategories[0].formGroups.length > 1;
        }
        return true;
    }

    getSelectedOptions() {
        // if (this.convertOptions) {
        //     return this.convertOptions.map(i => i.getSelectedOption());
        // }
        // TODO Preact fix this shouldnt be called, use the context to get the upto date options
        return {};
    }

    optionHasLessThanOneSelectionAndSelectionHasNoChildren(optionGroup: ConvertOption) {
        const isGroupHidden = optionGroup?.hiddenFn?.(this.props.convertOptionsContext.getConvertOptionCategories() as any)
        if (isGroupHidden) {
            return true;
        }

        if (optionGroup.selections.length > 1) {
            return false;
        }

        if (optionGroup.selections.length === 0) {
            return true;
        }

        const selection = optionGroup.selections[0];
        return !selection.formChildren;
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     const shownOptions = this.getShownOptionsAndUpdateSelectedOptionIfNeeded(this.props);
    //     const nextShownOptions = this.getShownOptionsAndUpdateSelectedOptionIfNeeded(nextProps);
    //     console.log(shownOptions, nextShownOptions, JSON.stringify(shownOptions) === JSON.stringify(nextShownOptions) )
    //     return false
    // }

    render() {
        const optionCategories = this.props?.convertOptionCategories?.formCategories;
        const optionGroups: { html: any, key: string, title: string }[] = [];

        if (optionCategories) {
            let i = 0;
            let j = 0;
            for (const category of optionCategories) {
                i++;
                if (category.formGroups) {
                    for (const optionGroup of category.formGroups) {
                        j++;
                        if (this.shouldDisplayCategory(category) && this.shouldDisplay(optionGroup) && !this.optionHasLessThanOneSelectionAndSelectionHasNoChildren(optionGroup)) {
                            const optionGroupHtml = <ConvertOptionComponent
                                formGroup={optionGroup}
                                formCategory={category}
                                uploadInProgressFiles={this.props.uploadInProgressFiles}
                                convertOptionsContext={this.props.convertOptionsContext}
                                selection={($event) => this.props.onOptionChange($event)}
                            ></ConvertOptionComponent>;
                            optionGroups.push({
                                title: optionGroup.formGroupDisplayName,
                                key: `key-${i}-${j}`,
                                html: optionGroupHtml,
                            });
                        } else {
                            // console.log('Skipped display for ', JSON.stringify(optionGroup));
                            // Skip
                        }

                    }
                }
            }
        }

        return optionGroups.map(group => {
            return <div className={styles['convert-option']} key={group.key} data-jkey="convert-option">
                <div className={`${styles["title"]}`}>{group.title}</div>
                <div className={`${styles["upload-type-parent"]}`} >
                    {group.html}
                </div>
            </div>
        });
        /*
                return (
                    optionCategories?.map((formCategory, index1) => {
                        return <div key={`${index1}`} className={`${styles["upload-type-parent-container"]}`}>
                            <div className={`${styles["title"]}`}>{formCategory.categoryLabel}</div>
                            <div className={`${styles["convert-options"]}`}>
                                {
                                    formCategory.formGroups.map((formGroup, index2) => {
                                        return this.shouldDisplay(formGroup) ? <div
                                            key={`${index1}-${index2}`}
                                            className={`${styles["upload-type-parent"]}`} >
                                            <ConvertOptionComponent
                                                formGroup={formGroup}
                                                formCategory={formCategory}
                                                fileUploads={this.props.fileUploads}
                                                convertOptionsContext={this.props.convertOptionsContext}
                                                selection={($event) => this.props.onOptionChange($event)}
                                            ></ConvertOptionComponent>
                                        </div> : ""
                                    })
                                }
                            </div>
                        </div>
                    })
        
                )*/
    }
}
